import { useEffect, useState } from "react";
import { safeParse } from "../safeParse";
/**
 * 通过localStorage实现多标签页共享状态
 * @param key
 * @param options
 * @returns
 */
export default function useTabShareState(key: string, { defaultValue = null }) {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  // 初始化时从localStorage中读取
  useEffect(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      setValue(safeParse(storedValue));
    }
  }, [key]);

  // 监听storage变化，同步更新
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === key) {
        setValue(safeParse(e.newValue));
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [key]);

  return [value, setValue];
}
